export default __webpack_public_path__ + "static/media/SusieDuke.ed1e80e2.jpg";